import { render } from "./QueueList.vue?vue&type=template&id=49aa911a&scoped=true&ts=true"
import script from "./QueueList.vue?vue&type=script&lang=ts"
export * from "./QueueList.vue?vue&type=script&lang=ts"

import "./QueueList.vue?vue&type=style&index=0&id=49aa911a&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49aa911a"]])

export default __exports__